// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"46ab57f7","85":"5cf7c449","174":"17f93bfa","237":"ca9fa647","323":"5c20940c","455":"e6b85eca","536":"f3496945","621":"544ba047","623":"8dcb5e07"}[chunkId] + ".chunk.js";
};